import { BASE_URL } from "./SystemConstants";


export default {
  BASE_URL: BASE_URL,
  GENERAL_ASSEMBLY_URL: BASE_URL + 'generalassembly',
  GENERAL_ASSEMBLY_GET: BASE_URL + 'generalassembly',
}
